import apiRoutes from '../apiRoutes';

export function getSkuRoutes(auth) {
  return apiRoutes(auth).routes.skuCategories();
}
